import { WorldpayInstance } from '../../models/worldpay/worldpay-instance.interface';
import { mockWorldpayOptions } from './worldpay-options.mock';

export const mockWorldpayInstance: WorldpayInstance = {
  destroy: () => null,
  instanceId: 1,
  isFakeLoadEvent: true,
  isPostMessage: true,
  lightboxMaxWidth: 1,
  onLoadInject: () => null,
  options: mockWorldpayOptions,
  populateForm: () => null,
  postMessageHandler: () => null,
  prefix: 'prefix',
  redirect: () => null,
  resize: () => null,
  scroll: () => null,
  sdkInfoAlreadySent: true,
  setup: () => null,
  submitForm: () => null,
  wpName: 'wpName',
};
